export default "__VITE_ASSET__DBOlTQKf__"